import { Stack } from '@mui/material';

import { useScrollable } from './useScrollable';

export const ScrollableContent = ({ children }: React.PropsWithChildren) => {
  const { isScrolledVertically, setIsScrolledVertically } = useScrollable();

  return (
    <Stack
      flexGrow={1}
      className='overflow-auto'
      onScroll={(event) => {
        const target = event.target as HTMLDivElement;
        if (typeof target.scrollTop === 'number') {
          const isScrolled = target.scrollTop > 0;
          if (isScrolled !== isScrolledVertically) {
            setIsScrolledVertically(isScrolled);
          }
        }
      }}
    >
      {children}
    </Stack>
  );
};
